import { AppState } from '@/types';
import { AppAction } from '../types';
import { getCurrentTier } from '@/lib/tierSystem';

export function handleRedeemPrize(state: AppState, action: Extract<AppAction, { type: 'REDEEM_PRIZE' }>): AppState {
  if (!state.isAuthenticated || state.activityCredits < action.payload.pointCost) {
    return state;
  }
  return {
    ...state,
    activityCredits: state.activityCredits - action.payload.pointCost,
    currentTier: getCurrentTier(state.totalPoints)
  };
}